// Sortierebene eines Formularfelds (`sortLevel`, #508).
//
// Client-Hälfte einer Regel, die es zweimal gibt. Die Quelle ist das Backend:
// `app/api/helper/checklist/sort_level.js` in `8p2-cld-backend`
// (`normalizeSortLevel`, `setSortLevel`). Der Server normalisiert jeden
// Einlasspfad und löscht, was keine Ganzzahl 1..9 ist.
//
// Warum die Regel hier noch einmal steht: wie bei `field_decimals.js` soll die
// Maske genau das annehmen, was der Server annimmt. Sonst tippt der Anwender
// `0` oder `1.5`, sieht den Wert stehen, speichert, und der Server verwirft
// ihn ohne Rückmeldung. Der Server bleibt die Absicherung, diese Datei ist die
// Fehlermeldung.
//
// Ändert sich die Regel, ändert sie sich in beiden Repos im selben Zug
// (Vertrag: `contracts/checklist-sort-level.md`).
export const MIN_SORT_LEVEL = 1;
export const MAX_SORT_LEVEL = 9;

/**
 * @param {*} value Rohwert aus dem Eingabefeld oder aus dem geladenen Datensatz.
 * @returns {number|undefined} Ganzzahl 1..9 oder `undefined` (= nicht gesetzt).
 */
export function normalizeSortLevel(value) {
  let n;
  if (typeof value === "number") {
    n = value;
  } else if (typeof value === "string") {
    const t = value.trim();
    // Wie im Backend: nur Ziffern. `Number()` nähme auch "0x3" oder "3e0".
    if (!/^[0-9]+$/.test(t)) return undefined;
    n = Number(t);
  } else {
    return undefined;
  }
  if (!Number.isInteger(n)) return undefined;
  if (n < MIN_SORT_LEVEL || n > MAX_SORT_LEVEL) return undefined;
  return n;
}
